import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import sueroImg from '../../assets/suero.jpg';

const ServiciosExpres = () => {
  const pageData = {
    title: "Servicios Exprés",
    metaDescription: "Enfermería exprés a domicilio en Guadalajara: visitas de 1 a 3 horas para aplicación de sueros, inyecciones o curaciones, sin necesidad de contratar un turno completo.",
    heroTitle: "Enfermería Exprés a Domicilio",
    heroSubtitle: "Visitas cortas y puntuales para una necesidad específica, sin contratar un turno completo",
    description: "El servicio exprés está pensado para cuando necesitas atención de enfermería para una tarea puntual y no un turno completo: aplicación de sueros o inyecciones, una curación, o un control de signos vitales. Personal certificado se traslada a tu domicilio, resuelve la necesidad específica y con las mismas medidas de bioseguridad que el resto de nuestros servicios.",
    benefits: [
      "Visitas de 1 a 3 horas según la tarea a realizar",
      "Aplicación de sueros intravenosos",
      "Inyecciones intramusculares y subcutáneas",
      "Curaciones y control de signos vitales",
      "Administración de medicamentos prescritos",
      "Sin necesidad de contratar un turno completo",
      "Personal certificado con protocolos de bioseguridad",
      "Cotización clara antes de agendar la visita"
    ],
    features: [
      {
        title: "Duración Ajustada",
        description: "Visitas de 1 a 3 horas, según la tarea específica que necesites"
      },
      {
        title: "Sin Compromiso de Turno",
        description: "Pagas por la visita puntual, no por un paquete de horas que no vas a usar"
      },
      {
        title: "Personal Certificado",
        description: "El mismo estándar de certificación y bioseguridad que nuestros demás servicios"
      },
      {
        title: "Ideal para Tareas Puntuales",
        description: "Sueros, inyecciones, curaciones o toma de signos vitales en una sola visita"
      },
      {
        title: "Equipamiento Completo",
        description: "Traemos el equipo necesario para la tarea a realizar"
      },
      {
        title: "Cotización Antes de Agendar",
        description: "Confirmamos contigo el alcance y el costo antes de la visita"
      }
    ],
    faqs: [
      {
        question: "¿Cuánto dura una visita exprés?",
        answer: "Entre 1 y 3 horas, dependiendo de la tarea que necesites: aplicación de suero, inyecciones, una curación o control de signos vitales."
      },
      {
        question: "¿Tengo que contratar un paquete de horas?",
        answer: "No. El servicio exprés es para una necesidad puntual, sin compromiso de turno completo ni de contrato mensual."
      },
      {
        question: "¿Qué tareas incluye el servicio exprés?",
        answer: "Aplicación de sueros y medicamentos, inyecciones intramusculares y subcutáneas, curaciones básicas y toma de signos vitales. Si tu necesidad requiere más tiempo o cuidado continuo, te orientamos hacia el servicio de enfermería por turnos."
      },
      {
        question: "¿Cómo sé el costo antes de agendar?",
        answer: "Te confirmamos el alcance de la visita y el costo por WhatsApp antes de agendar, para que no haya sorpresas."
      }
    ],
    relatedBlogSlugs: ['enfermeria-domicilio-guadalajara-2026'],
    image: sueroImg
  };

  return <ServiceLandingPage {...pageData} />;
};

export default ServiciosExpres;
